/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 public/meshes/Packaging_3v0.glb -o src/meshes/Packaging_3v0.tsx -r public -t -k -s -p 7 
Modified by: Aeroplane GLTFJSX Generator v1.9.1
*/

import { Group, AnimationAction, Mesh, MeshStandardMaterial, AnimationClip } from "three";
import { forwardRef, ForwardedRef, useEffect, useImperativeHandle, ForwardRefExoticComponent, useRef } from "react";
import { useGLTF, useAnimations } from "@react-three/drei";
import useM_CorrugatedCardboardEdge_News from "@materials/M_CorrugatedCardboardEdge_News";
import useM_CorrugatedCardboard_New from "@materials/M_CorrugatedCardboard_New";
import useM_PackagingPrint from "@materials/M_PackagingPrint";
import { GLTFJSXUtils } from "@utils/GLTFJSXUtils";
import { GLTF } from "three-stdlib";
import { ObjectUtils } from "@utils/ObjectUtils";
import { assetPath } from "@utils/Config";

const mesh = assetPath("/meshes/Packaging_3v0.glb");

type GLTFResult = GLTF & {
    nodes: {
        Outer_Box_New_1: Mesh;
        Outer_Box_New_2: Mesh;
        Outer_Box_New_3: Mesh;
    }
    materials: {
        M_PackagingPrint: MeshStandardMaterial;
        M_CorrugatedCardboardEdge_News: MeshStandardMaterial;
        M_CorrugatedCardboard_New: MeshStandardMaterial;
    }
    animations: GLTFAction[]
}

type ActionName = "KeyAction"
interface GLTFAction extends AnimationClip {
    name: ActionName
}
export type Handle = {
    root: Group | null;
    meshes: GLTFResult["nodes"];
    actions: Record<ActionName, AnimationAction | null>;
};
export function useHandle(ref: ForwardedRef<Group>) {
    const handle = useRef<Handle>(null);
    useEffect(() => {
        if (!ref) return;
        if (typeof ref === "function") ref(handle.current?.root ?? null);
        else ref.current = handle.current?.root ?? null;
    }, [handle, ref]);
    return handle;
};
export default forwardRef<Handle, JSX.IntrinsicElements["group"]>(function Model(props, ref) {
    const group = useRef<Group>(null);
    const { nodes, materials, animations } = useGLTF(mesh) as GLTFResult;
    const { actions } = useAnimations(animations, group);
    const M_CorrugatedCardboardEdge_News = useM_CorrugatedCardboardEdge_News();
    const M_CorrugatedCardboard_New = useM_CorrugatedCardboard_New();
    const M_PackagingPrint = useM_PackagingPrint();
    useImperativeHandle(ref, () => GLTFJSXUtils.createHandle<Handle>({ root: group.current, actions }, nodes), [group, nodes, actions]);
    return (
        <group ref={group} {...props} dispose={null}>
            <group name="Scene">
                <group name="Outer_Box_New">
                    <mesh name="Outer_Box_New_1" receiveShadow={props.receiveShadow} castShadow={props.castShadow} {...ObjectUtils.pick(nodes.Outer_Box_New_1, "geometry", "morphTargetDictionary", "morphTargetInfluences")} material={M_PackagingPrint} raycast={props.raycast} renderOrder={props.renderOrder} />
                    <mesh name="Outer_Box_New_2" receiveShadow={props.receiveShadow} castShadow={props.castShadow} {...ObjectUtils.pick(nodes.Outer_Box_New_2, "geometry", "morphTargetDictionary", "morphTargetInfluences")} material={M_CorrugatedCardboardEdge_News} raycast={props.raycast} renderOrder={props.renderOrder} />
                    <mesh name="Outer_Box_New_3" receiveShadow={props.receiveShadow} castShadow={props.castShadow} {...ObjectUtils.pick(nodes.Outer_Box_New_3, "geometry", "morphTargetDictionary", "morphTargetInfluences")} material={M_CorrugatedCardboard_New} raycast={props.raycast} renderOrder={props.renderOrder} />
                </group>
            </group>
        </group>
    );
});

useGLTF.preload(mesh, true, true);
